export const ENV = process.env.NODE_ENV;

export const getAPIUrl = (): string => {
  if (ENV === 'development') {
    return 'https://localhost:5042/api';
  }
  return process.env.REACT_APP_PORTAL_API as string;
};
